(function ($) {
  // Private functions
  function isAnswered(type, element) {
    if (type === "answered_trade") return true;
    let inputElement;
    let result;
    switch (type) {
      case "dropdown":
        inputElement = $(element).find("select.required")[0];
        break;
      case "radio":
        inputElement = $(element).find("input.required");
        break;
      default:
        inputElement = $(element).find("input.required")[0];
        break;
    }
    switch (type) {
      case "radio":
        result = inputElement.filter((_, e) => e.checked).length > 0;
        break;
      case "checkbox":
        result = inputElement.checked;
        break;
      default:
        result = inputElement.value !== "";
        break;
    }
    return result;
  }

  function isSectionAnswered(questionElement) {
    const result = questionElement.map(function (_, question) {
      let type;
      if ($(question).find("input.required").length > 0) {
        type = $(question).find("input.required")[0].type;
      } else if ($(question).find("select.required").length > 0) {
        type = "dropdown";
      } else if ($(question).find(".answer").length > 0) {
        type = "answered_trade";
      }
      if (typeof type !== "undefined") {
        return isAnswered(type, question);
      }
    });
    const answered = result.filter(function (_, a) {
      return a;
    });
    return answered.length === result.length;
  }

  // Public functions
  $.fn.sectionTracker = function (callback) {
    const self = $.fn.sectionTracker;
    self.callback = callback;
    self.element = this;
  };

  $.fn.sectionTracker.check = function () {
    const self = $.fn.sectionTracker;
    self.element.each(function (index, sectionElement) {
      const questionElement = $(sectionElement).find(".on .control");
      let result;
      if (questionElement.length > 0) {
        const sameCorrespondenceAddressYes = $(sectionElement).find(
          "#same_correspondence_address_yes"
        )[0];
        if (
          sameCorrespondenceAddressYes &&
          sameCorrespondenceAddressYes.checked
        ) {
          result = true;
        } else {
          result = isSectionAnswered(questionElement);
        }
        self.callback(sectionElement, index, result);
      }
    });
  };
})(window.jQuery);
